<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div class="searchBox">
          <div>
            <el-input placeholder="模糊搜索：作者/编号/标题" v-model="f_title" style="width: 400px">
              <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
            </el-input>
          </div>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" stripe :default-expand-all="false" :expand-row-keys="expandkeys" :row-key="getRowKeys" style="width: 100%">
            <el-table-column type="index" width="40" align="center"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"></el-table-column>

            <el-table-column prop="authorName" label="作者" width="80"></el-table-column>

            <el-table-column prop="createTime" label="投稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="lockTime" label="审稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.editorTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="step" label="状态">
              <template slot-scope="scope">
                <el-tag type="danger" v-if="scope.row.status == 3">已退稿</el-tag>
                <el-tag type="success" v-else-if="scope.row.status == 5">录用</el-tag>
                <el-tag type="primary" v-else-if="scope.row.status == 1">{{ getStatusText(scope.row.step) }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" align="right" width="240">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="showProcess(scope.row.id)" v-if="scope.row.step == 30">登记出版费</el-button>
                <el-button type="default" size="small" @click="showProcess(scope.row.id)">查看流程</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="curPage" @current-change="pageChange"> </el-pagination>
      </div>
    </div>

    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <div class="flex-1 d-flex flex-column">
        <div class="flex-1" style="padding: 0 20px 20px 20px">
          <ArticleProcess ref="ArticleProcess" :articleId="curArticleId" role="EDITOR" @bmfSubmitSuccess="bmfSubmitSuccess" @dcrateSubmitSuccess="dcrateSubmitSuccess"></ArticleProcess>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ArticleProcess from "@/components/ArticleProcess.vue"
import editorApi from "@/api/editor"
/**
 * 待评审页面
 * 步骤,100退稿。
 * 10作者提交稿件，
 * 20待编辑首次审稿
 * 30交审稿费。
 * 40专家首次审稿，41作者二次改稿,42专家第二次审稿。
 *
 * 50编辑查重，51作者三次改稿，52编辑二次查重。
 * 60登记版面费，出录用通知；
 * 70交版面费。
 * 80填写发票信息。
 * 90完成。
 */
export default {
  components: { PageHeader, ArticleProcess },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "已审稿件" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",
      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,
      drawer: false,
      drawerTitle: "",
      curArticleId: 0,

      expandkeys: [],
      getRowKeys(row) {
        return row.id
      },
    }
  },

  mounted() {
    //this.loadSubjects()
    this.loadData()
  },

  methods: {
    getStatusText(step) {
      for (let i = 0; i < this.$config.steps.length; i++) {
        if (step == this.$config.steps[i].step) {
          return this.$config.steps[i].title
        }
      }
      return ""
    },
    getStep(step) {
      var sw = parseInt(step / 10)
      var gw = step % 10
      var index = 1
      let arr = ["投稿", "编辑审稿", "支付审稿费", "专家审稿", "查重", "出版费登记", "支付出版费", "填写发票信息", "完成"]

      if (sw == 2) {
        if (gw == 0) {
          index = 1
        } else if (gw == 1) {
          arr[1] = "编辑首次审稿"
          arr.splice(2, 0, "作者一次改稿")
          index = 2
        } else if (gw == 2) {
          arr[1] = "编辑首次审稿"
          arr.splice(2, 0, "作者一次改稿")
          arr.splice(3, 0, "编辑二次审稿")
          index = 3
        }
      } else if (sw == 3) {
        index = 2
      } else if (sw == 4) {
        if (gw == 0) {
          index = 3
        } else if (gw == 1) {
          arr[3] = "专家首次审稿"
          arr.splice(4, 0, "作者二次改稿")
          index = 4
        } else if (gw == 2) {
          arr[3] = "专家首次审稿"
          arr.splice(4, 0, "作者二次改稿")
          arr.splice(5, 0, "专家二次审稿")
          index = 5
        }
      } else {
        index = sw - 1
      }

      return {
        index: index,
        data: arr,
      }
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },
    loadSubjects() {
      /* editorApi.mySubjectList().then((res) => {
        this.subjects = res.data
        this.subjects.unshift({
          subjectId: -1,
          subjectName: "所有版面/科目",
        })
        this.loadData()
      }) */
    },

    loadData() {
      this.tableData = []
      editorApi.articleListAudited(this.f_subjectId, this.f_title, "", "", this.curPage, this.pageSize).then((res) => {
        //this.tableData = res.rows
        this.total = res.total

        for (let i = 0; i < res.rows.length; i++) {
          let item = res.rows[i]
          let stepData = this.getStep(item.step)
          item.stepIndex = stepData.index
          item.stepData = stepData.data
          this.tableData.push(item)
        }
      })
    },

    openDraw(title) {
      this.drawer = true
      this.drawerTitle = title
    },

    showProcess(articleId) {
      this.openDraw("查看流程")
      this.curArticleId = articleId
    },

    bmfSubmitSuccess() {
      this.loadData()
    },

    dcrateSubmitSuccess() {
      this.loadData()
    },
  },
}
</script>

<style scoped>
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}

/deep/.el-drawer__body {
  display: flex;
}
/*
.searchItem label{
    width:100px;
    float:left;
    text-align: center;
}
.searchItem>div{
    margin-left: 120px;
}
.vTag{
    line-height: 30px;
    border:1px solid #ccc;
    border-radius: 3px;
    text-align: center;
    display: inline-block;
    margin-right: 10px;
    padding: 0 15px;
    font-size: 14px;
    cursor: pointer;

}
.vTag.actvie{
    background-color: #409eff;
    color:#FFF;
}
*/
</style>
